import { Component, ViewEncapsulation } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastNotificationService } from '../../../core/toast-notification.service';
import { UIBlockingService } from '../../../core/ui-blocking.service';
import { MemberInformationService } from '../member-information.service';

@Component({
  selector: 'app-introduce-yourself-modal',
  styleUrls: [
    "../../../../assets/css/public.css",
    "../../../../assets/css/overrides.css"],
  templateUrl: './introduce-yourself-modal.component.html',
  encapsulation: ViewEncapsulation.None,
    providers: [UIBlockingService],
})
export class IntroduceYourselfModalComponent {
  constructor(private activeModal: NgbActiveModal,
    private fb: FormBuilder,
    private notificationService: ToastNotificationService,
    private memberInformationService: MemberInformationService,
      private blockUI: UIBlockingService) { }

  letterContent: string;
  memberName: string;
  memberId: string
    hasError: boolean;

  submitLetter() {
      if (this.letterContent == null || this.letterContent == ""){
      this.hasError = true;
      return false;
    }
    var request = {
      letterContent: this.letterContent,
      requesteeId: this.memberId
    };
    this.blockUI.start();
    this.memberInformationService.submitLetterOfIntroduction(request)
        .subscribe({
            next: (data) => {
                this.blockUI.stop();
                this.activeModal.close(data);
            },
            error: (err) => {
                console.log(err)
                this.notificationService.error(err.error.message);
                this.blockUI.stop();
            },
        });

    return true;
  }


  dismiss() {
    this.activeModal.dismiss();
  }
}
